import { useState } from "react";
import { MyTransactionItem } from "../../hooks/useBalance";
import PhoneInput from "../../components/customer/PhoneInput";
import CustomerName from "../../components/customer/CustomerName";
import ZipcodeInput from "../../components/customer/ZipCodeInput";
import PointsResult from "../../components/customer/PointsResult";

interface MyBalanceData {
  name: string;
  amount: number;
  value: number;
  transactions: MyTransactionItem[];
}

const SearchMyPoints = (): JSX.Element => {
  const emptyCustomer: MyBalanceData = {
    name: "",
    amount: 0,
    value: 0,
    transactions: [],
  };

  const [stage, setStage] = useState(0);
  const [phone, setPhone] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [customer, setCustomer] = useState(emptyCustomer);

  const resetForm = () => {
    setStage(0);
    setPhone("");
    setZipcode("");
    setCustomer(emptyCustomer);
  };

  const isVisibleAtStage = (s: number): boolean => {
    return s >= 0 ? stage >= s : stage <= s;
  };

  const searchByPhone = () => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/customer/search-points/q?phone=${phone}`;
    fetch(url)
      .then((response) => response.json())
      .then((result) => {
        if (
          Object.keys(result?.data).length &&
          result?.data.customer_name !== ""
        ) {
          setCustomer({ ...emptyCustomer, name: result.data.customer_name });
          setStage(1);
        } else {
          setStage(-1);
        }
      });
  };

  const confirm = (isCorrect: boolean) => {
    setStage(isCorrect ? 2 : -1);
  };

  const search = () => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/customer/search-points/q?phone=${phone}&zipcode=${zipcode}`;
    fetch(url)
      .then((response) => response.json())
      .then((result) => {
        if (Object.keys(result?.data).length) {
          setCustomer({
            ...customer,
            value: result.data.value,
            amount: result.data.amount,
            transactions: result.data.transactions, // Backend already calculated balance
          });
          setStage(3);
        } else {
          setStage(-1);
        }
      });
  };

  return (
    <div>
      <PhoneInput
        phone={phone}
        setPhone={setPhone}
        onSearch={searchByPhone}
        onReset={() => resetForm()}
      />
      <CustomerName
        name={customer.name}
        visible={isVisibleAtStage(1)}
        onConfirm={confirm}
      />
      <ZipcodeInput
        zipcode={zipcode}
        setZipcode={setZipcode}
        onSearch={search}
        visible={isVisibleAtStage(2)}
        onReset={() => resetForm()}
      />
      {isVisibleAtStage(3) && (
        <PointsResult
          amount={customer.amount}
          value={customer.value}
          transactions={customer.transactions}
        />
      )}
      {isVisibleAtStage(-1) && (
        <div className="text-center py-8">
          <span className="text-destructive text-lg">
            Disculpa, no pudimos encontrar información.
          </span>
        </div>
      )}
    </div>
  );
};

export default SearchMyPoints;
